module.exports = __webpack_public_path__ + "static/media/Sub.ccdb44d5.jpg";